import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../../api/ApiProvider";
import notificationStore from "../Notification/notificationStore";
import { CreateKostentraegerDto, KostentraegerImportResultDto } from "../../api-client";
import { KostentraegerKeys } from "./kostentraeger.keys";

/**
 * Upload the latest Kostenträgerdateien. The backend stores them in blob
 * storage and runs the EDIFACT import in the same request.
 */
export const useUploadKostentraeger = () => {
  const { kostentraeger } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (files: File[]) => kostentraeger.uploadKostentraeger(files),
    onSuccess: (result: KostentraegerImportResultDto) => {
      notificationStore.showMessage(
        `Import erfolgreich: ${result?.files ?? 0} Datei(en), ${result?.payers ?? 0} Kostenträger, ` +
          `${result?.billingCenters ?? 0} Abrechnungszentren, ${result?.insuranceCards ?? 0} Kassen.`,
        "success"
      );
      queryClient.invalidateQueries({ queryKey: KostentraegerKeys.uploads.all() });
    },
    onError: (error: any) => {
      notificationStore.showMessage(
        error?.response?.data?.message ||
          "Fehler beim Hochladen/Import der Kostenträgerdateien.",
        "error",
        error
      );
    },
  });
};

/** Define a new Kostenträger manually (creates Insurer + Payer). */
export const useCreateKostentraeger = () => {
  const { kostentraeger } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dto: CreateKostentraegerDto) => kostentraeger.createKostentraeger(dto),
    onSuccess: () => {
      notificationStore.showMessage("Kostenträger erfolgreich erstellt.", "success");
      queryClient.invalidateQueries({ queryKey: KostentraegerKeys.uploads.all() });
    },
    onError: (error: any) => {
      notificationStore.showMessage(
        error?.response?.data?.message || "Fehler beim Erstellen des Kostenträgers.",
        "error",
        error
      );
    },
  });
};
